import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateListRequest, CreateSegmentRequest, Filter } from '@outreach/contracts';
import { api } from '@/lib/api';

export function useTags() {
  return useQuery({ queryKey: ['tags'], queryFn: () => api.tags.list() });
}
export function useLists() {
  return useQuery({ queryKey: ['lists'], queryFn: () => api.lists.list() });
}
export function useSegments() {
  return useQuery({ queryKey: ['segments'], queryFn: () => api.segments.list() });
}

export function useCreateList() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateListRequest) => api.lists.create(body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['lists'] }),
  });
}

export function useCreateSegment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateSegmentRequest) => api.segments.create(body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['segments'] }),
  });
}

/** On-demand audience preview for a stored/derived filter. */
export function useAudiencePreview() {
  return useMutation({ mutationFn: (filter: Filter) => api.audience.preview({ filter }) });
}
